// client/src/components/School_Admin/Dashboard/TeachersPerSubjectChart.js
//
// HOW MANY TEACHERS TAKE EACH SUBJECT — the secondary counterpart to
// TeachersPerClassChart.
//
// This was called TeachersPerDepartmentChart and labelled "Teachers per
// Department", but the series behind it has always grouped by `subject.name`:
// the server query joins TeacherSubject to Subject and never touches the
// departments table at all. So a secondary admin was reading a subject
// breakdown under a department heading, and nursery/primary — which has no
// departments — appeared to have them.
//
// Renamed rather than relabelled, so the file, the series and the heading all
// say the same thing and the next person does not have to read the SQL to find
// out which it is.
//
// Same DistributionPie as its neighbours: the three cards sit side by side and
// had already drifted into three different palettes once.

import React from 'react';
import DistributionPie from './DistributionPie';

const TeachersPerSubjectChart = ({ data }) => (
  <DistributionPie
    items={(Array.isArray(data) ? data : []).map((item) => ({
      // `subject` is the honest key; `department` is the old one, kept readable
      // so a client and server mid-deploy do not disagree.
      label: item.subject || item.department || item.name || 'Subject',
      value: item.count,
    }))}
    unitLabel="teachers"
    emptyText="No subject distribution data available"
  />
);

export default TeachersPerSubjectChart;
